module.exports = __webpack_public_path__ + "static/media/financial-skills-large@3x.2f86f472.png";